import React from 'react'
import { CustomCheckbox, CustomDataTableHeader } from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { consolidarProdutos } from './historicoLeitura.helpers'
import './TabHistorico.css'

export default function TabSeparacaoPorProduto({
  produtos,
  pickingStyle,
  showConsolidarLoteValidade = true,
}) {
  const [consolidarLoteValidade, setConsolidarLoteValidade] = React.useState(false)
  const [globalFilterProdutos, setGlobalFilterProdutos] = React.useState('')

  const exibirCheckbox = showConsolidarLoteValidade && pickingStyle !== 'Reconferencia'
  const exibirLoteValidade = exibirCheckbox && consolidarLoteValidade

  return (
    <>
      {exibirCheckbox && (
        <div style={{ marginBottom: 12 }}>
          <CustomCheckbox
            checked={consolidarLoteValidade}
            onChange={val => setConsolidarLoteValidade(val)}
          >
            Consolidar por Lote e Validade
          </CustomCheckbox>
        </div>
      )}
      <DataTable
        header={<CustomDataTableHeader onChange={setGlobalFilterProdutos} />}
        globalFilter={globalFilterProdutos}
        responsive={true}
        value={consolidarProdutos(produtos, {
          consolidarLoteValidade: exibirLoteValidade,
          pickingStyle,
        })}
        emptyMessage={'Nenhuma informação disponível'}
      >
        <Column
          className="column-responsive"
          field={'product_code'}
          header={'Código'}
          style={{
            ...tableCellCentered(
              Math.max(
                120,
                produtos.length
                  ? Math.max(...produtos.map(i => (i.product_code || '').length)) * 9
                  : 0,
              ),
            ),
            whiteSpace: 'nowrap',
            overflow: 'hidden',
          }}
          sortable
        />
        <Column
          className="column-responsive"
          field={'product_name'}
          header={'Produto'}
          style={{ width: '100%', textAlign: 'start' }}
          sortable
        />
        {exibirLoteValidade && (
          <Column
            className="column-responsive"
            field={'lote'}
            header={'Lote'}
            style={tableCellCentered(120)}
          />
        )}
        {exibirLoteValidade && (
          <Column
            className="column-responsive"
            field={'data_validade'}
            header={'Validade'}
            style={tableCellCentered(100)}
          />
        )}
        <Column
          className="column-responsive"
          field={'qte_total'}
          header={'Qte Total'}
          style={tableCellCentered(80)}
          sortable
        />
        <Column
          className="column-responsive"
          field={'qte_separada'}
          header={'Qte Separada'}
          style={tableCellCentered(100)}
          sortable
        />
        <Column
          className="column-responsive"
          field={'percentual_separacao'}
          header={'% Separação'}
          style={tableCellCentered(100)}
          sortable
          body={item => {
            if (!item.qte_total) return '0%'
            return ((item.qte_separada / item.qte_total) * 100).toFixed(0) + '%'
          }}
        />
      </DataTable>
    </>
  )
}
